export default __webpack_public_path__ + "static/media/FullCard.d4591221.svg";